import { render, staticRenderFns } from "./ButtonForm.vue?vue&type=template&id=142e3732"
import script from "./ButtonForm.vue?vue&type=script&lang=js"
export * from "./ButtonForm.vue?vue&type=script&lang=js"
import style0 from "./ButtonForm.vue?vue&type=style&index=0&id=142e3732&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports